import type { ReactNode } from "react";
import { Icon } from "@legal-500/legal500-design-system";
import { buildFileDisplayUri, getFileTypeLabel } from "@/utils/sharepointUrl";

export type SubmissionFileLinkProps = {
  /** The submission file URI. When absent the fallback is rendered. */
  fileUri?: string | null;
  /** Class applied to the anchor (lets callers reuse their own link styling). */
  className?: string;
  /** Rendered when there is no file URI. Defaults to an em dash. */
  fallback?: ReactNode;
};

/**
 * Renders a link to a submission's uploaded file. Extracted from the Submissions
 * list "File" column so the same markup/behaviour is reused by the delete modal.
 */
export function SubmissionFileLink({
  fileUri,
  className,
  fallback = "—",
}: SubmissionFileLinkProps) {
  if (!fileUri) {
    return <>{fallback}</>;
  }

  return (
    <a
      href={buildFileDisplayUri(fileUri)}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      title={fileUri}
      onClick={e => e.stopPropagation()}
    >
      <Icon icon="file" size="small" />
      <span>{getFileTypeLabel(fileUri)}</span>
    </a>
  );
}
